import { useQuery } from 'react-query';
import { documentModelsService } from 'hq/services';
import { QUERY_KEYS } from 'api/query-keys';
import { DocumentModel } from '@types';

export const useGetDocumentModels = () => {
  return useQuery<DocumentModel, Error>({
    queryKey: QUERY_KEYS.documentModels(),
    queryFn: () => {
      return documentModelsService.getDocumentModels();
    },
  });
};
